/* eslint-disable import/prefer-default-export */
import {
  all, takeLatest, call, put,
} from 'redux-saga/effects';
import API, { responseParser } from '../../services/api';
import { FETCH_LOGS, SET_LOGS } from './types';

function* getLogs({ payload }) {
  const response = yield call(api.getLogs, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_LOGS, payload: result });
  }
}

const api = API.create();
export function* combinedSagas() {
  yield all([yield takeLatest(FETCH_LOGS, getLogs)]);
}
